module.exports = __webpack_public_path__ + "img/payment_link.fcedf523.svg";